<template>
  <!--READ ONLY FIELDS-->
  <v-text-field
      v-if="field.field_type === 'read_only'"
      density="default"
      variant="underlined"
      color="primary"
      class="reg-normal mt-3"
      hide-details
      readonly
      persistent-placeholder
      v-model="new_value">
    <template #label>
      <span class="sm-bold text-primary">{{ $store.getters.translate(field.name) }}</span>
    </template>
  </v-text-field>
  <!--DISABLED FIELDS-->
  <template v-else-if="isDisabled">
    <v-text-field
        v-if="field.field_type === 'link'"
        density="default"
        variant="underlined"
        color="primary"
        hide-details
        readonly
        persistent-placeholder
        class="reg-normal mt-3"
        v-model="new_value">
      <template #label>
        <span class="sm-bold text-primary">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
      </template>
    </v-text-field>
    <v-text-field
        v-else-if="field.field_type === 'text_field' && (field.name === 'phonenumber' || field.name === 'mobilenumber')"
        density="default"
        variant="underlined"
        color="primary"
        hide-details
        readonly
        persistent-placeholder
        class="reg-normal mt-3"
        v-model="new_value"
        placeholder="+31612345678">
      <template #label>
        <span class="sm-bold text-primary">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
      </template>
    </v-text-field>
    <v-text-field
        v-else-if="field.field_type === 'date'"
        density="default"
        variant="underlined"
        color="primary"
        hide-details
        readonly
        persistent-placeholder
        class="reg-normal mt-3"
        v-model="new_value"
        v-mask="'##-##-####'"
        placeholder="dd-mm-yyyy">
      <template #label>
        <span class="sm-bold text-primary">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
      </template>
    </v-text-field>
    <v-text-field
        v-else-if="field.field_type === 'text_field'"
        density="default"
        variant="underlined"
        color="primary"
        hide-details
        readonly
        persistent-placeholder
        class="reg-normal mt-3"
        v-model="new_value">
      <template #label>
        <span class="sm-bold text-primary">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
      </template>
    </v-text-field>
<!--    <template v-else-if="field.field_type === 'text_area'">
      <span class="sm-bold text-primary">{{$store.getters.translate(field.name)}}</span><br/>
      <div v-html="new_value"/><br/>
    </template>-->
    <v-textarea
        v-else-if="field.field_type === 'text_area'"
        density="default"
        variant="underlined"
        color="primary"
        v-model="new_value"
        hide-details
        readonly
        persistent-placeholder
        class="reg-normal mt-3">
      <template #label>
        <span class="sm-bold text-primary">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory" ><strong>*</strong></span></span>
      </template>
    </v-textarea>
    <v-autocomplete
        v-else-if="field.field_type === 'select_single'"
        density="default"
        variant="underlined"
        color="primary"
        hide-details
        readonly
        persistent-placeholder
        class="reg-normal mt-3"
        v-model="new_value"
        :return-object="true"
        item-value="value"
        item-title="text"
        :items="$lodash.sortBy(field.available_options)">
      <template #label>
        <span class="sm-bold text-primary">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
      </template>
    </v-autocomplete>
    <v-autocomplete
        v-else-if="field.field_type === 'select_multiple'"
        density="default"
        variant="underlined"
        color="primary"
        hide-details
        readonly
        persistent-placeholder
        class="reg-normal mt-3"
        v-model="new_value"
        :return-object="false"
        item-value="value"
        item-title="text"
        :items="$lodash.sortBy(field.available_options)"
        multiple>
      <template #label>
        <span class="sm-bold text-primary">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
      </template>
    </v-autocomplete>
    <div v-else-if="field.field_type === 'boolean'" class="mt-3" style="display: flex;">
      <template v-if="field.name === 'not_smoking'">
        <PhCigaretteSlash v-if="field.name === 'not_smoking' && new_value" color="red" size="30"/>
        <PhCigarette v-else-if="field.name === 'not_smoking'" color="green" size="30"/>
      </template>
      <template v-else>
        <PhCheck v-if="new_value" color="green" size="30"/>
        <PhX v-else color="red" size="30"/>
        <span class="pl-3 sm-normal" style="display: block; height: 40px; align-content: center;">{{ $store.getters.translate(field.name) }}</span>
      </template>
    </div>
  </template>
  <!--ACTIVE FIELDS-->
  <template v-else>
    <v-text-field
        v-if="field.field_type === 'link'"
        density="default"
        class="reg-normal text-primary mt-3"
        base-color="border-tertiary"
        bg-color="secondary"
        color="primary"
        v-model="new_value"
        hide-details
        flat
        clearable>
      <template #label>
        <span class="sm-normal text-subtle">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
      </template>
    </v-text-field>
    <v-text-field
        v-else-if="field.field_type === 'text_field' && (field.name === 'phonenumber' || field.name === 'mobilenumber')"
        density="default"
        class="reg-normal text-primary mt-3"
        base-color="border-tertiary"
        bg-color="secondary"
        color="primary"
        v-model="new_value"
        hide-details
        flat
        clearable
        placeholder="+31612345678">
      <template #label>
        <span class="sm-normal text-subtle">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
      </template>
    </v-text-field>
    <v-text-field
        v-else-if="field.field_type === 'date'"
        density="default"
        class="reg-normal text-primary mt-3"
        base-color="border-tertiary"
        bg-color="secondary"
        color="primary"
        v-model="new_value"
        hide-details
        flat
        clearable
        v-mask="'##-##-####'"
        placeholder="dd-mm-yyyy">
      <template #label>
        <span class="sm-normal text-subtle">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
      </template>
    </v-text-field>
    <v-text-field
        v-else-if="field.field_type === 'text_field'"
        density="default"
        class="reg-normal text-primary mt-3"
        base-color="border-tertiary"
        bg-color="secondary"
        color="primary"
        v-model="new_value"
        hide-details
        flat
        clearable>
      <template #label>
        <span class="sm-normal text-subtle">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
      </template>
    </v-text-field>
    <v-textarea
        v-else-if="field.field_type === 'text_area'"
        density="default"
        class="reg-normal text-primary mt-3"
        base-color="border-tertiary"
        bg-color="secondary"
        color="primary"
        v-model="new_value"
        hide-details
        flat
        clearable>
      <template #label>
        <span class="sm-normal text-subtle">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory" ><strong>*</strong></span></span>
      </template>
    </v-textarea>
    <v-autocomplete
        v-else-if="field.field_type === 'select_single'"
        density="default"
        class="reg-normal text-primary mt-3"
        base-color="border-tertiary"
        bg-color="secondary"
        color="primary"
        v-model="new_value"
        :items="$lodash.sortBy(field.available_options)"
        :return-object="true"
        item-value="value"
        item-title="text"
        hide-details
        clearable>
      <template #label>
        <span class="sm-normal text-subtle">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
      </template>
      <template v-if="create" #append>
        <v-icon @click.stop="createNewModel" color="primary" size="large" icon="mdi-plus"/>
      </template>
    </v-autocomplete>
    <v-autocomplete
        v-else-if="field.field_type === 'select_multiple'"
        density="default"
        class="reg-normal text-primary mt-3"
        base-color="border-tertiary"
        bg-color="secondary"
        color="primary"
        v-model="new_value"
        :items="$lodash.sortBy(field.available_options)"
        :return-object="false"
        item-value="value"
        item-title="text"
        chips
        closable-chips
        hide-details
        clearable
        multiple>
      <template #label>
        <span class="sm-normal text-subtle">{{ $store.getters.translate(field.name) }}<span v-if="field.mandatory"><strong>*</strong></span></span>
      </template>
      <template v-if="create" #append>
        <v-icon @click.stop="createNewModel" color="primary" size="large" icon="mdi-plus"/>
      </template>
    </v-autocomplete>
    <div v-else-if="field.field_type === 'boolean'" class="mt-3" style="display: flex;">
      <v-checkbox style="float: left;" color="success" density="compact" hide-details v-model="new_value"/>
      <span class="pl-3 sm-normal" style="display: block; height: 40px; align-content: center;">{{ $store.getters.translate(field.name) }}</span>
    </div>
  </template>
</template>

<script>
import {PhCheck, PhCigarette, PhCigaretteSlash, PhX} from "@phosphor-icons/vue";

export default {
  components: {PhX, PhCheck, PhCigarette, PhCigaretteSlash},
  props: ["modelValue", "field", "action", "isDisabled", "create"],
  data() {
    return {
      new_value: null,
    };
  },
  mounted() {
    if(this.field.field_type === 'select_single') {
      this.new_value = this.field.available_options.find(option => option.value === this.modelValue);
    }
    else {
      this.new_value = this.modelValue;
    }
  },
  methods: {
    createNewModel() {
      this.$emit('create', this.field.name);
    },
  },
  watch: {
    new_value: {
      handler() {
        let data = [];
        if(this.field.field_type === 'select_single') {
          if(this.new_value) {
            data = [this.field.name, this.new_value.value, this.new_value.text];
          }
          else {
            data = [this.field.name, null, ''];
          }
        }
        else {
          data = [this.field.name, this.new_value];
        }
        this.$emit('change', data);
      },
      deep: true
    },
    modelValue: {
      handler() {
        if(this.field.field_type === 'select_single') {
          this.new_value = this.field.available_options.find(option => option.value === this.modelValue);
        }
        else {
          this.new_value = this.modelValue;
        }
      },
      deep: true
    },
  },
};
</script>